import React, { useEffect } from 'react'
import { useSlashID } from '@slashid/react'
import { AUTH_HUB_LOGOUT_URL } from 'utils/auth-config'

/**
 * Redirects to auth hub when user is not authenticated.
 * Only redirects when SlashID SDK is ready, so we don't redirect
 * while initialToken is still being processed.
 */
const RedirectToAuthHub: React.FC = () => {
  const { user, sdkState } = useSlashID()

  useEffect(() => {
    if (sdkState === 'ready' && !user) {
      window.location.replace(AUTH_HUB_LOGOUT_URL)
    }
  }, [sdkState, user])

  return null
}

export default RedirectToAuthHub
